// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__QI7b2","Success":"Button__Success__2dHUt","submit":"Button__submit__1S6Oo","ButtonActive":"Button__ButtonActive__1cEXT","Danger":"Button__Danger__2xnhN","Neutral":"Button__Neutral__2cf24","Orange":"Button__Orange__H4SNI","Disabled":"Button__Disabled__mXG4J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 137
// module chunks = 0